import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a news icon (Newsfeed new icon).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NewsIcon width={12} />
 */
const NewsIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M9.2,16.4H6.91a.9.9,0,0,0-.91.89H6V27.78a.91.91,0,0,0,.91.9H9.18a.91.91,
            0,0,0,.91-.9V17.3a.88.88,0,0,0-.86-.9ZM41.09,6H40a.88.88,0,0,0-.83.54,73.92,73.92,0,0,1-27.54,
            9.64V28.92c1.72.26,3.42.56,5.09.92V40.63A1.37,1.37,0,0,0,18.07,42h1.48a1.37,1.37,0,0,0,1.37-1.35v-9.8a70.9,
            70.9,0,0,1,18.21,7.69.91.91,0,0,0,.83.54h1.1a.92.92,0,0,0,.92-.9V6.9a.88.88,0,0,0-.86-.9Z`}
        />
    </SvgIcon>
)

NewsIcon.defaultProps = defaultProps

export { NewsIcon }
